<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent">To assist you in your choice of route we have provided a summary of all twelve routes in the guidebook together with an indication as to their suitability for walkers, cyclists or car tourists. Distances are in km – the first figure in the table – and miles. You will find that the circular alpha/numeric references in the text of each route correspond directly with those on the relevant map.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 37_fm045.vue?d49de1ba